import type { SVGProps } from 'react';
const SvgArrowDropdownSmallWithoutBg = ({ color, style, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
    style={color ? { ...(style ?? {}), color } : style}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.13 12.908 12 16.89l3.87-3.982"
    />
  </svg>
);
export default SvgArrowDropdownSmallWithoutBg;
